module.exports = __webpack_public_path__ + "img/9@3x.a35f763f.png";